import { ServiceFetch } from '../service-fetch'

export default class ReceiptListModel extends ServiceFetch {
    getReceiptListBy = (data) => this.authFetch({
        url: 'receipt-list/getReceiptListBy',
        method: 'POST',
        body: JSON.stringify(data),
    })

    generateReceiptListBy = (data) => this.authFetch({
        url: 'receipt-list/generateReceiptListBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}